import * as types from './types'
import store from '@/Store'

export default {
  [types.SET_MERGETAGS](state, data) {
    state.mergeTags = []
    if (data !== undefined && data !== null) {
      state.mergeTags = data
    }
  },
  [types.RESET_WALLMESSAGES](state) {
    state.wallmessages = []
    state.cursorUrl = null
  },
  [types.RESET_WALLMESSAGE](state, data) {
    state.wallmessage = JSON.parse(JSON.stringify(state.defaultWallMessage))
    state.wallmessage.user_id = data.id
    state.wallmessage.organization_id = data.orgId
  },
  [types.SET_WORKINGTEXT](state, text) {
    state.workingText = text
  },
  [types.SET_READCOUNT](state, data) {
    console.log('Setting Read Count', data)
    let found = state.wallmessages.find(
      (x) => parseInt(x.user_id) === parseInt(data.data.memberId)
    )
    if (found) {
      console.log('Found Member, updating Unread Count', {
        found: found,
        currentUnread: found.unread_messages,
        newUnread: data.count,
      })
      found.unread_messages = data.count.toString()

      store.dispatch('usercardio/setUnreadMessages', data)
    }
  },
  [types.SET_WALLMESSAGES](state, data) {
    state.mergeTags = null
    if (data !== undefined && data !== null) {
      state.mergeTags = data.mergeTags
      if (state.cursorUrl) {
        let temp = JSON.parse(JSON.stringify(state.wallmessages))
        state.wallmessages = temp.concat(data.messages.data)
      } else {
        state.wallmessages = data.messages.data
      }
      state.cursorUrl = null
      if (data.messages.next_page_url) {
        if (data.messages.next_page_url) {
          let url = data.messages.next_page_url
          state.cursorUrl = url.substring(
            url.indexOf('cursor=') + 7,
            url.length
          )
        }
      }
    }
  },
  [types.SET_WALLMESSAGE](state, data) {
    state.wallmessage = null
    if (data !== undefined && data !== null) {
      let found = state.wallmessages.find((x) => x.id === data.msg.id)
      if (found) {
        if (found.read_by) {
          let ids = found.read_by.split(' ')
          if (!ids.includes(data.userid.toString())) {
            found.read_by = found.read_by + ' ' + data.userid.toString()
          }
        }
      }
      state.wallmessage = data.msg
    }
  },
  [types.SET_WALLMESSAGE_DATA](state, data) {
    switch (data.name) {
      case 'userid': {
        state.wallmessage.user_id = data.value
        break
      }
      case 'orgid': {
        state.wallmessage.organization_id = data.value
        break
      }
      case 'subject': {
        state.wallmessage.subject = data.value
        break
      }
      case 'body': {
        state.wallmessage.body = data.value
        break
      }
      case 'type': {
        state.wallmessage.type = data.value
        break
      }
      case 'isInactive': {
        state.wallmessage.isInactive = data.value
        break
      }
      case 'isInvite': {
        state.wallmessage.isInvite = data.value
        break
      }
    }
  },
  [types.SET_ALLREAD](state, data) {
    state.wallmessages.forEach((message) => {
      let isRead = false
      let readIds = []
      if (message.read_by !== '' && message.from_coach === 0) {
        if (message.read_by.includes(' ')) {
          readIds = message.read_by.split(' ')
          if (readIds.includes(data.id.toString())) {
            isRead = true
          }
        } else {
          if (message.read_by === data.id.toString()) {
            isRead = true
          }
        }
      } else if (message.from_coach === 1) {
        isRead = true
      }
      if (isRead === false) {
        if (message.read_by !== '') {
          message.read_by = message.read_by + ' ' + data.id.toString()
        } else {
          message.read_by = data.id.toString()
        }
      }
    })
  },
}
